import { BrandLockup } from '@agentic-flow-studio/shared/components/brand-lockup';
import { InboxClinicLogo } from '@agentic-flow-studio/shared/components/inbox-clinic-logo';

/** Inbox Clinic's brand lockup for signed-out pages, above the centered card. */
export function PublicBrand() {
  return (
    <BrandLockup
      brandName="Inbox Clinic"
      nameClassName="font-display font-normal"
      logo={<InboxClinicLogo className="h-7 w-7" />}
    />
  );
}
